export default {
  check_new_notifications: 'Kunne ikke sjekke siste meldinger',
  create_profile: 'Kunne ikke lage profil, prøv igjen',
  edit_post: 'Kunne ikke endre ditt innlegg',
  firebase: 'Firebase error',
  get_activities: 'Kunne ikke hente aktiviteter',
  get_challenge: 'Kunne ikke hente utfordring',
  get_challenges: 'Kunne ikke hente utfordringer',
  get_challenge_teams: 'Kunne ikke hente lagutfordringer',
  get_global_events: 'Kunne ikke hente siste globale hendelser',
  get_global_static_events: 'Global static event error',
  get_department_events: 'Kunne ikke hente siste hendelser for din avdeling',
  get_team_events: 'Kunne ikke hente siste hendelser for ditt lag',
  get_user_events: 'Kunne ikke hente dine siste hendelser',
  get_latest_comments: 'Kunne ikke hente siste kommentarer',
  get_leaderboard_users: 'Kunne ikke hente oversikt over beste brukere',
  get_logged_activities: 'Kunne ikke hente loggførte aktiviteter',
  get_section_static_events: 'Section static evebt error',
  get_selected_team_day_score:
    'Kunne ikke hente dagens poengsum for laget ditt',
  get_team_leaderboard_6:
    'Kunne ikke hente oversikt over de 6 beste på laget ditt',
  get_team_score: 'Kunne ikke hente lagets poengsum',
  get_team_static_events: 'Team static event error',
  get_team_total_score: 'Kunne ikke hente total poengsum',
  get_posts: 'Kunne ikke hente posts',
  get_profile: 'Kunne ikke laste profilen, prøv å laste siden på nytt',
  get_profile_challenges: 'Kunne ikke hente utfordringer',
  get_household_challenges: 'Kunne ikke hente utfordringer',
  get_user_static_events: 'User static event error',
  get_users_logged_activities:
    'Kunne ikke hente denne brukerens loggførte aktiviteter',
  http: 'HTTP error',
  join_challenge: 'Kunne ikke bli med i utfordring',
  join_organisation: 'Kunne ikke bli med i organisasjonen',
  log_out: 'Kunne ikke logge deg ut, prøv igjen',
  no_organisations: 'Fant ikke bedrifter',
  no_profiles: 'Fant ikke profiler',
  remove_image: 'Kunne ikke slette bilde',
  remove_post: 'Kunne ikke slette innlegg',
  save_bookmark: 'Kunne ikke lagre ditt bokmerke',
  save_comment: 'Kunne ikke lagre din kommentar',
  save_post_like: 'Kunne ikke lagre din like',
  share_post: 'Kunne ikke dele innlegg',
  send_feedback: 'Kunne ikke sende tilbakemelding',
  send_new_password: 'Kunne ikke sende nytt passord',
  set_profile_challenges: 'Kunne ikke lagre utfordringer',
  toggle_log_activity: 'Kunne ikke endre loggførte aktiviteter',
  update_last_seen_notifications: 'Kunne ikke oppdatere siste',
  update_profile: 'Kunne ikke oppdatere profilen, prøv igjen',
  error: 'Det oppstod en feil',
  E102: 'Feil passord',
  E301: 'Denne koden er ugyldig',
  E302: 'Din epost kan ikke bli med i denne kampanjen',
  E900: 'En feil oppstod, vennligst prøv igjen',
  E901: 'For mange forespørsler. Vennligst vent en stund og prøv igjen.',
  must_be_numeric: 'Koden må bestå av 6 tall',
};
